import slugify from 'slugify';
import { tocItems } from '@openclassrooms/ui-web/table-of-content';
import { ROUTES, getPathName } from '@openclassrooms/routing';

export default function tocItemToUrl(courseItem, tocItem) {
  const slugifyOptions = { lower: true };
  const isExercise = tocItems.isExercise(tocItem);

  const courseIdSlug = `${courseItem.id}-${slugify(courseItem.title, slugifyOptions)}`;

  const route = isExercise ? ROUTES.COURSES.EXERCISES : ROUTES.COURSES.CHAPTERS;
  const params = isExercise
    ? { courseIdSlug, exerciseId: tocItem.id }
    : { courseIdSlug, chapterIdSlug: `${tocItem.id}-${slugify(tocItem.title, slugifyOptions)}` };

  const link = getPathName(route, params, false);

  return link;
}
